import * as React from 'react';

/*
 * Manage Job and Devices
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { Button, Col } from 'react-bootstrap';
import { WithTranslation, withTranslation } from 'react-i18next';
import { FieldConfig } from 'react-reactive-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { useTable, Column, useSortBy, usePagination, useRowSelect, Row, useFlexLayout } from 'react-table';
import * as types from '../../actions/actionTypes';
import { getContactsByFacility } from '../../actions/contactsActions';
import {
    clearTableFilter,
    getCommissioningInstallBases,
    getInventory,
    setSelectedProduct,
    setTableFilter as setTableFilterAction,
    toggleCommissioningDataFormModal,
    toggleEditInstallModal,
    toggleEditJobDefaultsModal,
    toggleModalNotePad,
    toggleModalSignaturePad,
    updateInstallBaseSelection
} from '../../actions/manageInventoryActions';
import { addWorkOrdersToJob, setJobFinalCheckMoal, updateJob } from '../../actions/manageJobActions';
import {
    bulkCannotCompleteSelected,
    getMeasurementPointListResultsForJobs
} from '../../actions/measurementPointResultsActions';
import {
    setSelectedWorkOrderID,
    toggleAddRepairWorkOrderModal,
    toggleConfirmSelectJobModal
} from '../../actions/workOrderActions';
import { constants } from '../../constants/constants';
import {
    IWorkOrder,
    Ifacility,
    IinstallBasePopulated,
    Ijob,
    IjobPopulated,
    Ioption,
    Iproduct,
    IproductInfo,
    ItableFiltersParams,
    ItableFiltersReducer,
    Itile,
    Iuser,
    WorkOrderSource
} from '../../models';
import {
    jobStatusEnum,
    jobTypesIdEnum,
    jobTypesIdEnumInverse,
    measurementPointResultStatusTypesEnum,
    workOrderStatusEnum
} from '../../models-enums';
import { IinitialState } from '../../reducers';
import {
    selectIsLoading,
    selectOfflineStatusForJob,
    selectOfflineStatusForJobTest,
    selectOutbox
} from '../../reducers/commonReducers';
import { selectIsJobReadOnly, selectJobWorkOrdersForCurrentJob } from '../../reducers/commonSelectors';
import { getIsMobile } from '../../reducers/configReducer';
import { initialFacility, initialInstallBasePopulated, initialJob } from '../../reducers/initialState';
import { selectIsWorkOrderMode } from '../../reducers/locationReducer';
import {
    filterInstallBases,
    getProducts,
    getRefreshInventory,
    selectFilterConfig,
    selectInstallBasesByID,
    selectInventoryNoDataText,
    showManageInventoryLoading
} from '../../reducers/manageInventoryReducer';
import {
    getIsAddWorkOrderMode,
    getIsCommissioningTypeJob,
    getIsMaintenanceTypeJob,
    getIsWorkOrderTypeJob,
    jobFinalCheckModalOn
} from '../../reducers/manageJobReducer';
import { Banner } from '../common/Banner';
import { FormUtil } from '../common/FormUtil';
import Loading from '../common/Loading';
import SearchTableForm from '../common/SearchTableForm';
import FilterAssetTableModal from '../common/mobile/FilterAssetTableModal';
import EditJobModal from '../manageJob/EditJobModal';
import CommissioningDataSignatureModal from '../workOrder/CommissioningDataSignatureModal';
import ConfirmSelectJobModal from '../workOrder/ConfirmSelectJobModal';
import WorkOrderCloseModal from '../workOrder/WorkOrderCloseModal';
import AddFSEModal from './AddFSEModal';
import AddHoursModalContainer from './AddHoursModalContainer';
import CommissioningDataModal from './CommissioningData/CommissioningDataModal';
import EditFacilityContactsModal from './EditFacilityContactsModal';
import EditInstallModal from './EditInstallModal';
import EditJobDefaultsModal from './EditJobDefaults/EditJobDefaultsModal';
import EditProductModal from './EditProductModal';
import JobCommentsModal from '../manageJobComment/JobCommentsModal';
import VirtualSapWOPartsModal from './VirtualSapWOPartsModal';
import { InventoryActionButtonContainer } from './InventoryActionButtonContainer';
import {
    isAlreadyOnJob,
    rowIdsToSelection,
    selectionToRowIds,
    toRowId,
    toSelectionKey
} from './inventorySelectionUtil';
import { JobFinalCheckModal } from './JobFinalCheckModal';
import NoteModal from './NoteModal';
import { SearchInventoryTableContainer } from './SearchInventoryTableContainer';
import SearchNewProductsModal from './SearchNewProductsModal';
import SignatureModal from './SignatureModal';

/* Custom react-table action handled by the stateReducer passed to useTable below. */
const CLEAR_ALL_SELECTED_ROWS = 'clearAllSelectedRows';

interface Iprops extends RouteComponentProps<any> {
    // Add your regular properties here
    showNotePadModal: boolean;
    showEditProductModal: boolean;
    showEditInstallModal: boolean;
    showSignatureModal: boolean;
    loading: boolean;
}

interface IdispatchProps {
    // Add your dispatcher properties here
    toggleCommissioningDataFormModal: typeof toggleCommissioningDataFormModal;
    toggleConfirmSelectJobModal: typeof toggleConfirmSelectJobModal;
    toggleEditInstallModal: typeof toggleEditInstallModal;
    toggleModalSignaturePad: typeof toggleModalSignaturePad;
    toggleModalNotePad: typeof toggleModalNotePad;
    getCommissioningInstallBases: typeof getCommissioningInstallBases;
    getMeasurementPointListResultsForJobs: typeof getMeasurementPointListResultsForJobs;
    toggleSecurityFunctionsModal: () => void;
    getContactsByFacility: typeof getContactsByFacility;
    productInfo: IproductInfo;
    facilityOptions: Ioption[];
    user: Iuser;
    setTableFilter: (filters: ItableFiltersParams) => any;
    tableFilters: ItableFiltersReducer;
    selectedProduct: Iproduct;
    setSelectedProduct: typeof setSelectedProduct;
    selectedJob: Ijob;
    updateJob: typeof updateJob;
    openedInspectionJobIDs: string[];
    workOrderUpdatedSuccess?: string;
    toggleEditJobDefaultsModal: typeof toggleEditJobDefaultsModal;
    showSearchNewProductsModal: boolean;
    facility: Ifacility;
    addWorkOrdersToJob: typeof addWorkOrdersToJob;
    updateInstallBaseSelection: typeof updateInstallBaseSelection;
    selection: string[];
    enableBulkInstallBaseMode: boolean;
    showAdditionalFilters?: boolean;
    isMaintenanceTypeJob: boolean;
    isWorkOrderTypeJob: boolean;
    isAddWorkOrderMode: boolean;
    setSelectedWorkOrderID: typeof setSelectedWorkOrderID;
    noDataText: string;
    bulkCannotCompleteSelected: typeof bulkCannotCompleteSelected;
    isRepairTypeJob: boolean;
    isCommissioningTypeJob: boolean;
    isJobDownloaded: boolean;
    lastSync: number;
    clearTableFilter: typeof clearTableFilter;
}

interface Istate {
    selectedRow: any;
    selectedInstall: IinstallBasePopulated;
    selectAll: boolean;
    showFilterSearch: boolean;
    isMenuOpen: boolean;
}

const ManageInventory: React.FC<Iprops & IdispatchProps & WithTranslation> = props => {
    const prevProps = React.useRef<(Iprops & IdispatchProps & WithTranslation) | undefined>();
    const upperWrap = React.useRef<HTMLDivElement>(null);
    const {
        t,
        updateInstallBaseSelection: updateIBS,
        history,
        isRepairTypeJob,
        isCommissioningTypeJob,
        isJobDownloaded,
        isWorkOrderTypeJob,
        location,
        selection: propsSelection,
        selectedJob,
        user,
        setTableFilter
    } = props;
    const finalJobCheckModal = useSelector(jobFinalCheckModalOn);
    const outbox = useSelector(selectOutbox);
    const [buttonInAction] = React.useState<boolean>(false);
    const [state, setState] = React.useState<Istate>({
        selectedRow: {},
        selectedInstall: initialInstallBasePopulated,
        selectAll: false,
        showFilterSearch: false,
        isMenuOpen: false
    });

    React.useEffect(() => {
        if (propsSelection.length === 0) {
            setState(st => ({ ...st, selectAll: false }));
        }
    }, [propsSelection]);
    const dispatch = useDispatch();
    const currentTile: Itile = React.useMemo(() => constants.getTileByURL(location.pathname), [location.pathname]);

    let tableClassName = `ReactTable beacon-table -highlight ${currentTile.color}`;
    // selectors
    const isAddWorkOrderMode = useSelector(selectIsWorkOrderMode);
    const isJobDownloadedTest = useSelector(selectOfflineStatusForJobTest);
    const isJobReadOnly = useSelector(selectIsJobReadOnly);
    const filteredInstallBases = useSelector(filterInstallBases);
    const installBases = useSelector(selectInstallBasesByID);
    const products = useSelector(getProducts);

    const mobileFilterConfig = useSelector(selectFilterConfig);
    const isMobile = useSelector(getIsMobile);
    const shouldRefreshInventory = useSelector(getRefreshInventory);
    const setTableFilterDebounced = debounce<(formValues: { [key: string]: any }) => void>(
        props.setTableFilter,
        constants.formDebounceTime
    );
    const jobWorkOrders = useSelector(selectJobWorkOrdersForCurrentJob);
    const showLoading = useSelector(showManageInventoryLoading);
    const productSyncChunksDone = useSelector((reduxState: IinitialState) =>
        reduxState.syncStatus.isBackgroundProductSyncRunning
            ? reduxState.syncStatus.backgroundProductSyncFinishedCount
            : null
    );

    React.useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (outbox && outbox.length > 0) {
                // This triggers the confirmation dialog
                const message =
                    'You have pending items to sync, please wait until they are complete or you may lose data.'; // Browsers won't actually use custom text it seems
                event.preventDefault();
                event.returnValue = message; // Required for some browsers to show the prompt
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [outbox]);

    const searchFieldConfig: FieldConfig = React.useMemo(() => {
        const { search } = props.tableFilters;
        const disabled = false;
        const mainSearchControls = {
            search: {
                // TODO adding scope for this in a change request. waiting for approval.  Still need to update view to flow to two rows when on smaller width
                render: FormUtil.TextInputWithoutValidation,
                meta: {
                    label: 'search',
                    colWidth: 5,
                    colWidthLarge: 4,
                    type: 'text',
                    placeholder: t('manageInventory:tableFilters.searchPlaceholder'),
                    showClearButton: true,
                    clearAriaLabel: t('common:clear')
                },
                formState: { value: search, disabled }
            }
        };

        return { controls: { ...mainSearchControls } };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tableFilters.search]);

    const hasVirtualProduct = (ibs: IinstallBasePopulated[]) => {
        const anyVirtualProducts = ibs?.some(installBase => {
            return installBase?.product?.subcategoryID === constants.virtualProductSubcategoryID;
        });

        return anyVirtualProducts;
    };

    const scrollTop = React.useCallback(() => {
        const tableDiv = document.getElementsByClassName('rt-tbody');

        if (tableDiv && tableDiv.length) {
            if (tableDiv[0]) {
                tableDiv[0].scrollTop = 0;
                // upperWrap.current?.scrollIntoView(); TODO: DO NOT COMMIT THIS.
            }
        }
    }, []);

    const checkForEmptyRepairJob = React.useCallback(() => {
        const { jobTypeID } = selectedJob;
        if (jobTypeID === jobTypesIdEnum.repair) {
            const isEmpty = jobWorkOrders.length === 0 && filteredInstallBases.length === 0;
            // let anySAPWorkOrders = false;
            let ibs: any = [];

            if (jobWorkOrders && jobWorkOrders.length > 0) {
                jobWorkOrders.forEach((jwo: any) => {
                    if (jwo && jwo.workOrder && jwo.workOrder.installBase) {
                        ibs.push(jwo.workOrder.installBase);

                        // if (jwo.workOrder.source === WorkOrderSource.SAP) {
                        //     anySAPWorkOrders = true;
                        // }
                    } else if (jwo && jwo.workOrder) {
                        // Convert this to IinstallBasePopulated so we can attach a product
                        const foundIB = installBases[jwo.workOrder.installBaseID] as IinstallBasePopulated;
                        if (foundIB) {
                            // Attach the product
                            const product = products[foundIB.materialID];
                            if (product) {
                                foundIB.product = product;
                                ibs.push(foundIB);
                            }

                            // if (jwo.workOrder.source === WorkOrderSource.SAP) {
                            //     anySAPWorkOrders = true;
                            // }
                        }
                    }
                });
            }

            if (isEmpty) {
                history.push('/repair');
                toastr.warning(t('toastMessage:warning'), t('toastMessage:addAssetsToJob'), constants.toastrWarning);
            }
            // Check if any added work orders have a virtual product, if so, take user to the repair screen so they can added assets
            // Since virtuals are automatically filtered out now, filteredInstallBases might be empty, so check ibs as well
            else if (
                (filteredInstallBases.length === 1 && hasVirtualProduct(filteredInstallBases)) ||
                (ibs.length === 1 && hasVirtualProduct(ibs))
            ) {
                history.push('/repair');
                toastr.warning(t('toastMessage:warning'), t('toastMessage:addAssetsToJob'), constants.toastrWarning);
            } else {
                history.push('/devices');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobWorkOrders, filteredInstallBases, selectedJob, history, t]);

    const checkForEmptyServicePlanJob = React.useCallback(() => {
        const { jobTypeID } = selectedJob;
        const isEmpty = jobWorkOrders.length === 0 && filteredInstallBases.length === 0;

        if (jobTypeID === jobTypesIdEnum.servicePlan && isEmpty) {
            history.push('/repair');
            toastr.warning(t('toastMessage:warning'), t('toastMessage:addAssetsToJob'), constants.toastrWarning);
        }
    }, [jobWorkOrders, filteredInstallBases, selectedJob, history, t]);

    const checkForEmptyCommissioningJob = React.useCallback(() => {
        const { jobTypeID } = selectedJob;

        if (jobTypeID === jobTypesIdEnum.commissioning && filteredInstallBases.length === 0) {
            history.push('/repair');
            toastr.warning(t('toastMessage:warning'), t('toastMessage:emptyCommissioningJob'), constants.toastrWarning);
        }
    }, [filteredInstallBases, selectedJob, history, t]);

    const checkForEmptyMaintenanceJob = React.useCallback(() => {
        const { jobTypeID } = selectedJob;
        if (jobTypeID === jobTypesIdEnum.maintenance && filteredInstallBases.length === 0) {
            history.push('/maintenance');
            toastr.warning(t('toastMessage:warning'), t('toastMessage:emptyMaintenanceJob'), constants.toastrWarning);
        }
    }, [filteredInstallBases, selectedJob, history, t]);

    const checkForEmptyWarrantyJob = React.useCallback(() => {
        const { jobTypeID } = selectedJob;
        if (jobTypeID === jobTypesIdEnum.warrantyBM && filteredInstallBases.length === 0) {
            history.push('/warranty');
            toastr.warning(t('toastMessage:warning'), t('toastMessage:addAssetsToJob'), constants.toastrWarning);
        }
    }, [filteredInstallBases, selectedJob, history, t]);

    const handleUpdatedInstallBases = React.useCallback(() => {
        updateIBS([]);
    }, [updateIBS]);

    /**
     * Toggle a single checkbox for select table
     */
    const toggleSelection = (key: string, shift: boolean, row: any) => {
        // if (row && row.isVirtual && row.isVirtual === true) {
        //     return;
        // }

        // start off with the existing state
        let selection = [...propsSelection];
        const keyIndex = selection.indexOf(key);

        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)];
        } else {
            // it does not exist so add it
            selection.push(key);
        }
        // reset the single selected install
        setState(st => ({ ...st, selectedInstall: initialInstallBasePopulated }));
        // update the state
        updateIBS(selection);
    };

    const tableData: IinstallBasePopulated[] = React.useMemo(() => {
        if (isJobDownloadedTest) {
            // If Job is Inspection or AGSS, don't show Virtual Products unless the Install base has a work order from SAP
            if (
                props.selectedJob.jobTypeID === jobTypesIdEnum.inspection ||
                props.selectedJob.jobTypeID === jobTypesIdEnum.agsRebalancing
            ) {
                return filteredInstallBases.filter((installBase: IinstallBasePopulated) => {
                    if (
                        installBase.product &&
                        installBase.product.subcategoryID === constants.virtualProductSubcategoryID
                    ) {
                        if (installBase.workOrders && installBase.workOrders.length > 0) {
                            if (
                                installBase.workOrders.some(
                                    (workOrder: IWorkOrder) => workOrder.source === WorkOrderSource.SAP
                                )
                            ) {
                                return true;
                            }
                        }
                        return false;
                    } else {
                        return true;
                    }
                });
            } else {
                return filteredInstallBases;
            }
        }
        return [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredInstallBases, isJobDownloadedTest]);

    /**
     * Toggle all checkboxes for select table
     */
    // const toggleAll = () => {
    //     const selection: string[] = [];
    //     const selectAll = !state.selectAll;
    //     if (selectAll) {
    //         // we just push all the IDs onto the selection array
    //         tableData.forEach(item => {
    //             // Don't select any virtual products
    //             let virtualProduct = false;
    //             if (item.isVirtual && item.isVirtual === true) {
    //                 virtualProduct = true;
    //             }

    //             if (!virtualProduct) {
    //                 selection.push(`select-${item.id}`);
    //             }
    //         });
    //     }
    //     setState(st => ({ ...st, selectAll }));
    //     updateIBS(selection);
    // };

    /**
     * Whether or not a row is selected for select table
     */
    // const isSelected = (key: string) => {
    //     return propsSelection.includes(`select-${key}`);
    // };

    /*
     * Set Columns sets columns to state
     * setting columns here in order to reset them if and after we receive mainCategory and manufacturer options
     * The status column does not display when the job type is an Audit because there is no testing in an audit job
     */
    const columns = React.useMemo<Column<IinstallBasePopulated>[]>(() => {
        const mainColumns: Column<IinstallBasePopulated>[] = [
            {
                Header: ({
                    rows,
                    toggleAllRowsSelected,
                    toggleRowSelected,
                    state: { selectedRowIds: tableSelectedRowIds }
                }: any) => {
                    const alreadyOnJobRows: Row<IinstallBasePopulated>[] = rows.filter(
                        (r: Row<IinstallBasePopulated>) => isAlreadyOnJob(r.original, isAddWorkOrderMode)
                    );
                    const eligibleCount = rows.length - alreadyOnJobRows.length;
                    const selectedCount = rows.filter(
                        (r: Row<IinstallBasePopulated>) =>
                            tableSelectedRowIds[r.id] && !isAlreadyOnJob(r.original, isAddWorkOrderMode)
                    ).length;
                    const checked = eligibleCount > 0 && selectedCount === eligibleCount;
                    const indeterminate = selectedCount > 0 && !checked;
                    const checkboxRef = React.useRef<HTMLInputElement>(null);

                    React.useEffect(() => {
                        if (checkboxRef.current) {
                            checkboxRef.current.indeterminate = indeterminate;
                        }
                    }, [indeterminate]);

                    return (
                        <div className="d-flex">
                            <input
                                type="checkbox"
                                ref={checkboxRef}
                                onClick={e => e.stopPropagation()}
                                style={{ cursor: 'pointer' }}
                                checked={checked}
                                onChange={() => {
                                    userSelectionChangeRef.current = true;
                                    toggleAllRowsSelected(!checked);
                                    alreadyOnJobRows.forEach(r => toggleRowSelected(r.id, false));
                                }}
                            />
                        </div>
                    );
                },
                id: 'selection',
                width: 40,
                minWidth: 40,
                maxWidth: 40,
                Cell: ({ row }: any) => {
                    const {
                        indeterminate,
                        onChange: onRowToggleChange,
                        ...checkboxProps
                    } = row.getToggleRowSelectedProps();
                    const checkboxRef = React.useRef<HTMLInputElement>(null);

                    React.useEffect(() => {
                        if (checkboxRef.current) {
                            checkboxRef.current.indeterminate = indeterminate;
                        }
                    }, [indeterminate]);

                    if (isAlreadyOnJob(row.original, isAddWorkOrderMode)) {
                        return (
                            <div className="d-flex justify-content-center">
                                <input type="checkbox" checked disabled readOnly />
                            </div>
                        );
                    }

                    return (
                        <div className="d-flex justify-content-center">
                            <input
                                type="checkbox"
                                ref={checkboxRef}
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                                {...checkboxProps}
                                onChange={e => {
                                    userSelectionChangeRef.current = true;
                                    if (onRowToggleChange) {
                                        onRowToggleChange(e);
                                    }
                                }}
                            />
                        </div>
                    );
                }
            },
            {
                Header: isMobile ? 'check all' : 'location',
                id: 'location',
                accessor: ({ locationString, isVirtual }: IinstallBasePopulated) => {
                    const cssStyle = isVirtual ? 'disabled-label' : '';
                    return (
                        <>
                            <span key="label" className={`${cssStyle} mobile-label`}>
                                Loc
                            </span>
                            <span key="value" className={cssStyle}>
                                {locationString}
                            </span>
                        </>
                    );
                },
                width: 100,
                minWidth: 100,
                maxWidth: 150
            },
            {
                Header: isMobile ? '' : t('manageInventory:serialNumber'),
                id: 'serialNumber',
                accessor: ({ serialNumber, isVirtual }: IinstallBasePopulated) => {
                    const cssStyle = isVirtual ? 'disabled-label' : '';
                    return (
                        <>
                            <span key="label" className={`${cssStyle} mobile-label`}>
                                S/N
                            </span>
                            <span key="value" className={cssStyle}>
                                {serialNumber}
                            </span>
                        </>
                    );
                },
                width: 120,
                minWidth: 100,
                maxWidth: 150
            },
            {
                Header: isMobile ? '' : 'name',
                accessor: ({
                    product: { name, description, sapMaterialNumber },
                    isVirtual,
                    sapEquipmentNumber
                }: IinstallBasePopulated) => {
                    const nameParts: string[] = [];
                    const cssStyle = isVirtual ? 'disabled-label' : '';
                    const cssLoading = name === '' ? 'loading-skele' : '';

                    nameParts.push(name);
                    if (sapMaterialNumber) {
                        nameParts.push(sapMaterialNumber);
                    }

                    if (description) {
                        nameParts.push(description);
                    }

                    const newName: string = nameParts.join(': ');
                    return (
                        <>
                            <span className={`${cssStyle} mobile-label`}>Name</span>
                            <span className={`${cssStyle} ${cssLoading} ${sapEquipmentNumber ? 'blue-bold' : ''}`}>
                                {newName}
                            </span>
                        </>
                    );
                },
                id: 'name',
                width: 400,
                maxWidth: 500
            }
        ];

        const statusColumn: Column<IinstallBasePopulated>[] = [
            {
                Header: <span>{t('manageInventory:status')}</span>,
                id: 'status',
                accessor: (base: IinstallBasePopulated) => {
                    const { latestMeasurementPointListResult, workOrderResultStatus, isVirtual } = base;
                    const cssStyle = isVirtual ? 'disabled-label' : '';
                    let status = latestMeasurementPointListResult.status;

                    if (isWorkOrderTypeJob) {
                        return (
                            <>
                                <span className={`${cssStyle} mobile-label`}>Status</span>
                                <span
                                    className={`${cssStyle} status ${workOrderStatusEnum[workOrderResultStatus]} type-${workOrderResultStatus}`}
                                >{`${t('manageWorkOrder:' + workOrderStatusEnum[workOrderResultStatus])}`}</span>
                            </>
                        );
                    }

                    // These statuses are a nightmare...even though we are expecting latestMeasurementPointListResult to have the real thing, sometimes it doesn't...
                    if (
                        base.latestMeasurementPointListResultStatus &&
                        status !== base.latestMeasurementPointListResultStatus
                    ) {
                        status = base.latestMeasurementPointListResultStatus;
                    }

                    return (
                        <>
                            <span className={`${cssStyle} mobile-label`}>Status</span>
                            <span
                                className={`${cssStyle} status ${measurementPointResultStatusTypesEnum[status]} type-${status}`}
                            >{`${t(
                                'manageMeasurementPointLists:' + measurementPointResultStatusTypesEnum[status]
                            )}`}</span>
                        </>
                    );
                },
                width: 120,
                minWidth: 60
            }
        ];

        // when repairing, users want to see which asset has failed
        const repairStatusColumn: Column<IinstallBasePopulated>[] = [
            {
                Header: isMobile ? '' : 'status',
                id: 'status',
                accessor: ({ originalMeasurementPointListResultStatus, isVirtual }: IinstallBasePopulated) => {
                    const cssStyle = isVirtual ? 'disabled-label' : '';
                    return (
                        <>
                            <span className={`${cssStyle} mobile-label`}>Status</span>
                            <span
                                className={`${cssStyle} status ${measurementPointResultStatusTypesEnum[originalMeasurementPointListResultStatus]} type-${originalMeasurementPointListResultStatus}`}
                            >{`${t(
                                'manageMeasurementPointLists:' +
                                    measurementPointResultStatusTypesEnum[originalMeasurementPointListResultStatus]
                            )}`}</span>
                        </>
                    );
                },
                width: 120,
                minWidth: 60
            }
        ];

        let finalColumns: Column<IinstallBasePopulated>[];
        if (isRepairTypeJob === true && isAddWorkOrderMode === true) {
            finalColumns = [...mainColumns, ...repairStatusColumn];
        } else if (isAddWorkOrderMode === true) {
            finalColumns = mainColumns;
        } else {
            finalColumns = [...mainColumns, ...statusColumn];
        }

        return finalColumns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRepairTypeJob, isCommissioningTypeJob, isMobile, isWorkOrderTypeJob, isAddWorkOrderMode, t]);

    const handleRowClick = (row: Row<IinstallBasePopulated>) => {
        if (!row) {
            return;
        }

        if (!buttonInAction) {
            // Do not allow virtual products to be opened
            const selectedInstall: IinstallBasePopulated = row.original;
            if (selectedInstall.isVirtual) {
                return;
            }

            // If we have historical MP to copy, but it doesn't match the current install base, clear that history. This can happen if you copy history,
            // then go to a new asset, you'll end up with the history copied to the wrong asset.
            dispatch({ type: 'CLEAR_HISTORICAL_MP_TO_COPY' });

            // If you're on a repair job, selecting assets to add to the job, don't navigate to device screen, toggle the selection instead
            if (
                (props.selectedJob.jobTypeID === jobTypesIdEnum.repair ||
                    props.selectedJob.jobTypeID === jobTypesIdEnum.servicePlan ||
                    props.selectedJob.jobTypeID === jobTypesIdEnum.commissioning) &&
                history.location.pathname === '/repair'
            ) {
                toggleSelection(toSelectionKey(row.original.id), false, null);
            } else if (
                props.selectedJob.jobTypeID === jobTypesIdEnum.warrantyBM &&
                history.location.pathname === '/warranty'
            ) {
                toggleSelection(toSelectionKey(row.original.id), false, null);
            } else {
                history.push(`/devices/${row.original.id}`);
            }
        }
    };

    const onSortedChanged = React.useCallback(
        (newSorted: any[], column: any, shiftKey: boolean) => {
            props.setTableFilter({ sorted: newSorted });
            setState(st => ({ ...st, selectedRow: {} }));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.setTableFilter]
    );

    const canEditInstalls = React.useCallback(() => {
        const manageInventory =
            constants.hasSecurityFunction(user, constants.securityFunctions.ManageInventory.id) ||
            constants.hasSecurityFunction(user, constants.securityFunctions.FSE.id);
        if (!manageInventory) {
            toastr.warning(
                'Warning',
                'user does not have permission to edit devices.  Please contact support',
                constants.toastrWarning
            );
        }
    }, [user]);

    const onPageChange = React.useCallback(
        (page: number) => {
            setTableFilter({ page });
        },
        [setTableFilter]
    );

    const onPageSizeChange = React.useCallback(
        (rows: number) => {
            setTableFilter({ rows, page: 0 });
        },
        [setTableFilter]
    );

    const setBannerTitle = (isWorkOrderMode: boolean, jobTypeID: string) => {
        if (isWorkOrderMode && (jobTypeID === jobTypesIdEnum.repair || jobTypeID === jobTypesIdEnum.servicePlan)) {
            return t('bannerTitleMobileWorkOrderMode');
        } else if (isWorkOrderMode && jobTypeID === jobTypesIdEnum.warrantyBM) {
            return t('manageInventory:warranty');
        } else if (jobTypeID === jobTypesIdEnum.repair || jobTypeID === jobTypesIdEnum.servicePlan) {
            return t('bannerTitleRepairs');
        } else {
            return t('bannerTitleMobile');
        }
    };

    const initialize = () => {
        checkForEmptyRepairJob();
        checkForEmptyServicePlanJob();
        checkForEmptyCommissioningJob();
        checkForEmptyMaintenanceJob();
        checkForEmptyWarrantyJob();
    };

    const onSearchValueChanges = React.useCallback(
        (value: any, key: string) => {
            switch (key) {
                case 'startDate': {
                    const startDateMoment = moment.isMoment(value) ? value : moment(value);
                    setTableFilterDebounced({
                        startDate: startDateMoment.toISOString(),
                        page: 0
                    });

                    break;
                }
                default:
                    setTableFilterDebounced({ [key]: value, page: 0 });
            }
        },
        [setTableFilterDebounced]
    );

    if (props.showAdditionalFilters) {
        tableClassName = tableClassName + ' additional-filters';
    }

    if (isAddWorkOrderMode) {
        tableClassName = tableClassName + ' adding-workorder';
    }

    const colorButton = constants.colors[`${currentTile.color}Button` as keyof typeof constants.colors];
    const jobType: string = t(jobTypesIdEnumInverse[selectedJob.jobTypeID] + 'Job');
    // TODO Turn this into a selector
    const bannerTitle = setBannerTitle(isAddWorkOrderMode, selectedJob.jobTypeID);
    const jobLabel = `${jobType}: ${selectedJob.jobNumber}`;
    const bannerSubSubTitle =
        isAddWorkOrderMode === true ? '' : isJobReadOnly ? `${jobLabel} - ${t('common:readOnly')}` : jobLabel;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        resetSelection();
        scrollTop();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAddWorkOrderMode]);

    React.useEffect(() => {
        if (prevProps?.current?.showEditInstallModal !== props.showEditInstallModal && !props.showEditInstallModal) {
            props.setSelectedProduct();
            setState(st => ({ ...st, selectedInstall: initialInstallBasePopulated }));
        }

        // scroll to top on any filter change; reset selection only when content filters change
        const prev = prevProps?.current?.tableFilters;
        const curr = props.tableFilters;
        if (JSON.stringify(prev) !== JSON.stringify(curr)) {
            scrollTop();
        }
        const contentFilterChanged =
            prev?.measurementPointListResultStatus?.value !== curr?.measurementPointListResultStatus?.value ||
            prev?.workOrderResultStatus?.value !== curr?.workOrderResultStatus?.value ||
            prev?.hideVirtualDecommissionedToggle !== curr?.hideVirtualDecommissionedToggle ||
            prev?.search !== curr?.search ||
            prev?.mainCategory?.value !== curr?.mainCategory?.value ||
            prev?.building?.value !== curr?.building?.value ||
            prev?.floor?.value !== curr?.floor?.value ||
            prev?.location?.value !== curr?.location?.value ||
            (prev?.rooms || []).map(r => r.value).sort().join(',') !==
                (curr?.rooms || []).map(r => r.value).sort().join(',') ||
            prev?.system?.value !== curr?.system?.value;
        if (contentFilterChanged) {
            resetSelection();
        }

        if (props.isJobDownloaded === true && prevProps?.current?.isJobDownloaded === false) {
            toastr.success(t('toastMessage:success'), t('toastMessage:jobDownloadSuccess'), {
                ...constants.toastrSuccess,
                timeOut: 5000
            });
        }

        prevProps.current = props;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showEditInstallModal, props.tableFilters, t]);

    React.useEffect(() => {
        document.addEventListener('updatedInstallBases', handleUpdatedInstallBases, false);

        dispatch(setJobFinalCheckMoal(false));
        updateIBS([]);
        canEditInstalls();

        initialize();

        return () => {
            document.removeEventListener('updatedInstallBases', handleUpdatedInstallBases, false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // After bulk action is complete, refresh inventory
    React.useEffect(() => {
        if (shouldRefreshInventory !== '') {
            dispatch(getInventory(selectedJob.facilityID));
            let toastSuccess = 'toastMessage:mobileBulkPassResultsSuccessMessage';
            toastr.success(t('success'), t(toastSuccess), constants.toastrSuccess);

            // Reset the flag to show the bulk action was completed
            dispatch({
                type: types.UPDATE_MEASUREMENT_POINT_RESULT_BULK_SUCCESS,
                meta: { id: '' }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldRefreshInventory]);

    // if (props.productInfo.mainCategoryOptions.length === 0) {
    //     return (
    //         <Col xs={12}>
    //             <h4> loading... </h4>
    //         </Col>
    //     );
    // }

    // Convert Redux selection format to react-table format (only on mount)
    const initialSelectedRowIds = React.useMemo(() => {
        return selectionToRowIds(propsSelection);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tableInstance = useTable(
        {
            columns,
            data: tableData,
            getRowId: (row: IinstallBasePopulated) => row.id,
            initialState: {
                pageIndex: props.tableFilters.page || 0,
                pageSize: props.tableFilters.rows || constants.tablePageSizeDefault,
                sortBy: props.tableFilters.sorted || [],
                selectedRowIds: initialSelectedRowIds
            } as any,
            /*
             * MMG-4443: paging writes the new page into tableFilters, which makes
             * filterInstallBases recompute and hand useTable a brand new `data` array. With
             * react-table's default autoReset, that identity change throws the row selection back
             * to `initialState.selectedRowIds` - the snapshot taken at mount - so a tick made after
             * mount vanished as soon as the technician clicked Next or Previous, while Redux
             * quietly kept it (Add Selected Assets stayed enabled over an empty-looking list).
             * Selection is cleared deliberately elsewhere: resetSelection() on a content filter
             * change, the effect below that drops rows no longer visible, and Clear Selection.
             */
            autoResetSelectedRows: false,
            /*
             * toggleAllRowsSelected(false) only unticks rows that are currently in the table, so a
             * row the active filter has hidden keeps its tick and reappears ticked when the filter
             * is lifted. With the auto reset above turned off nothing else wipes those, so give the
             * clearing paths an action that empties selectedRowIds outright.
             */
            stateReducer: (newState: any, action: any) =>
                action.type === CLEAR_ALL_SELECTED_ROWS ? { ...newState, selectedRowIds: {} } : newState,
            manualPagination: false,
            manualSortBy: true,
            pageCount: Math.ceil(tableData.length / (props.tableFilters.rows || constants.tablePageSizeDefault))
        } as any,
        useSortBy,
        usePagination,
        useRowSelect,
        useFlexLayout
    ) as any;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page: tablePage,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        toggleRowSelected,
        dispatch: tableDispatch,
        state: { pageIndex, pageSize, sortBy, selectedRowIds }
    } = tableInstance;

    /** Empty selectedRowIds, including ticks on rows the current filter is hiding. */
    const clearAllSelectedRows = React.useCallback(() => {
        tableDispatch({ type: CLEAR_ALL_SELECTED_ROWS });
    }, [tableDispatch]);

    // Table state sync effects
    React.useEffect(() => {
        if (sortBy.length > 0) {
            onSortedChanged(sortBy, null, false);
        }
    }, [sortBy, onSortedChanged]);

    React.useEffect(() => {
        if (pageIndex !== props.tableFilters.page) {
            onPageChange(pageIndex);
        }
    }, [pageIndex, props.tableFilters.page, onPageChange]);

    React.useEffect(() => {
        if (pageSize !== props.tableFilters.rows) {
            onPageSizeChange(pageSize);
        }
    }, [pageSize, props.tableFilters.rows, onPageSizeChange]);

    // Track last synced values to prevent infinite loop
    const lastSyncedSelection = React.useRef<string[]>([]);
    const suppressRestoreRef = React.useRef<boolean>(false);
    const isProgrammaticSelectionChangeRef = React.useRef<boolean>(false);
    const userSelectionChangeRef = React.useRef<boolean>(false);
    // Always-current ref so the restore effect can read selectedRowIds without depending on it.
    const selectedRowIdsRef = React.useRef(selectedRowIds);
    selectedRowIdsRef.current = selectedRowIds;

    // Sync react-table selection TO Redux
    React.useEffect(() => {
        const selectedIds = rowIdsToSelection(selectedRowIds);

        // Ignore updates while we are restoring programmatically
        if (isProgrammaticSelectionChangeRef.current) {
            return;
        }

        // Only update Redux if selection actually changed
        const selectionChanged =
            selectedIds.length !== lastSyncedSelection.current.length ||
            !selectedIds.every(id => lastSyncedSelection.current.includes(id));
        const shrinkingComparedToRedux =
            selectedIds.length < propsSelection.length && selectedIds.every(id => propsSelection.includes(id));

        if (selectionChanged && userSelectionChangeRef.current) {
            // If the table was cleared by the user, suppress immediate restore
            if (selectedIds.length === 0) {
                suppressRestoreRef.current = true;
            }
            lastSyncedSelection.current = selectedIds;
            updateIBS(selectedIds);
            // reset user flag after dispatch
            userSelectionChangeRef.current = false;
        } else if (selectionChanged && !userSelectionChangeRef.current) {
            // Never shrink Redux due to incidental re-renders
            if (shrinkingComparedToRedux) {
                return;
            }
            // If somehow the table has more selected than Redux (rare), allow expansion
            if (selectedIds.length > propsSelection.length) {
                lastSyncedSelection.current = selectedIds;
                updateIBS(selectedIds);
            }
        }
    }, [selectedRowIds, updateIBS, propsSelection]);

    // Sync Redux selection TO react-table when externally modified or when table loses selection
    React.useEffect(() => {
        const reduxSelection = propsSelection.map(toRowId);

        // If a user-initiated clear is in progress, don't restore until Redux reflects empty
        if (suppressRestoreRef.current) {
            if (propsSelection.length === 0) {
                suppressRestoreRef.current = false;
            }
            return;
        }

        const tableSelectedIds = Object.keys(selectedRowIdsRef.current);
        const tableHasNoSelection = tableSelectedIds.length === 0;
        const reduxHasSelection = propsSelection.length > 0;

        // If the table lost its selection but Redux still has it, restore all from Redux
        if (tableHasNoSelection && reduxHasSelection) {
            isProgrammaticSelectionChangeRef.current = true;
            clearAllSelectedRows();
            reduxSelection.forEach(id => {
                toggleRowSelected(id, true);
            });
            // release guard on next tick to avoid partial mid-restore updates
            setTimeout(() => {
                isProgrammaticSelectionChangeRef.current = false;
            }, 0);
            lastSyncedSelection.current = propsSelection;
            return;
        }

        // If Redux has more selected than the table, add only missing ones
        if (reduxHasSelection && !tableHasNoSelection) {
            const tableSelectedSet = new Set(tableSelectedIds);
            const missing = reduxSelection.filter(id => !tableSelectedSet.has(id));
            if (missing.length > 0) {
                isProgrammaticSelectionChangeRef.current = true;
                missing.forEach(id => {
                    toggleRowSelected(id, true);
                });
                setTimeout(() => {
                    isProgrammaticSelectionChangeRef.current = false;
                }, 0);
                lastSyncedSelection.current = propsSelection;
                return;
            }
        }

        // Only sync if Redux changed externally (not from our own dispatch to it)
        const reduxDifferentFromLastSync =
            propsSelection.length !== lastSyncedSelection.current.length ||
            !propsSelection.every(id => lastSyncedSelection.current.includes(id));

        if (reduxDifferentFromLastSync) {
            isProgrammaticSelectionChangeRef.current = true;
            clearAllSelectedRows();
            reduxSelection.forEach(id => {
                toggleRowSelected(id, true);
            });
            setTimeout(() => {
                isProgrammaticSelectionChangeRef.current = false;
            }, 0);
            lastSyncedSelection.current = propsSelection;
        }
    }, [propsSelection, clearAllSelectedRows, toggleRowSelected]);

    // When tableData changes (e.g. hide toggle flipped), drop any selected items no longer visible
    React.useEffect(() => {
        if (propsSelection.length === 0) return;

        const visibleIds = new Set(
            tableData
                .filter(item => !isAlreadyOnJob(item, isAddWorkOrderMode))
                .map(item => toSelectionKey(item.id))
        );
        const validSelection = propsSelection.filter(id => visibleIds.has(id));

        if (validSelection.length === propsSelection.length) return;

        isProgrammaticSelectionChangeRef.current = true;
        clearAllSelectedRows();
        validSelection.forEach(id => toggleRowSelected(toRowId(id), true));
        setTimeout(() => { isProgrammaticSelectionChangeRef.current = false; }, 0);
        lastSyncedSelection.current = validSelection;
        updateIBS(validSelection);
    }, [tableData, isAddWorkOrderMode, propsSelection, updateIBS, clearAllSelectedRows, toggleRowSelected]);

    // Reset selection function that clears all selection state
    const resetSelection = React.useCallback(() => {
        if (propsSelection.length > 0) {
            setState(st => ({ ...st, selectAll: false }));
            updateIBS([]);
            clearAllSelectedRows();
        }
    }, [propsSelection, updateIBS, clearAllSelectedRows]);

    // return home if there is no job or the job has been completed, unless the approver is viewing it
    if (!selectedJob.id.length || (selectedJob.status === jobStatusEnum.completed && !isJobReadOnly)) {
        return (
            <Redirect
                to={{
                    pathname: '/jobs'
                }}
            />
        );
    }

    // handle onMenuToggle callback
    const onMenuToggle = (isOpen: boolean) => {
        setState(st => ({ ...st, isMenuOpen: isOpen }));
    };

    const handleHideVirtualChange = (checked: boolean) => {
        setTableFilter({ hideVirtualDecommissionedToggle: checked, page: 0 });
    };

    return (
        <div
            className="manage-inventory"
            data-location={location.pathname.replace('/', '')}
            data-btn="true"
            data-manage="true"
            data-empty={tableData.length === 0}
        >
            {/* <Loading
                show={!props.isJobDownloaded}
                message={'Please wait...  loading hospital data'}
                downloadSpeed={undefined}
            /> */}
            <Loading show={showLoading} message={'Please wait...  preparing data'} downloadSpeed={undefined} />
            <div ref={upperWrap} className="upper-wrap" data-menuopen={state.isMenuOpen}>
                <Banner
                    title={bannerTitle}
                    img={currentTile.srcBanner}
                    color={currentTile.color}
                    subtitle={props.facility.name}
                    subsubtitle={bannerSubSubTitle}
                />
                <SearchInventoryTableContainer
                    facility={props.facility}
                    colorButton={colorButton}
                    installBasesPopulated={tableData}
                    history={history}
                    location={location}
                    match={props.match}
                    resetSelection={resetSelection}
                />
                {isMobile && (
                    <div className="search-form-container">
                        {searchFieldConfig && (
                            <SearchTableForm
                                fieldConfig={searchFieldConfig}
                                handleSubmit={() => {
                                    return;
                                }}
                                loading={props.loading}
                                colorButton={
                                    constants.colors[`${currentTile.color}Button` as keyof typeof constants.colors]
                                }
                                t={props.t}
                                subscribeValueChanges={true}
                                onValueChanges={onSearchValueChanges}
                                showSearchButton={false}
                            />
                        )}

                        <Col className="search-actions-container" xs={12}>
                            <Button
                                disabled={props.loading}
                                className="mng-job-filter"
                                onClick={() => {
                                    setState(currSt => ({ ...currSt, showFilterSearch: true }));
                                }}
                            >
                                <FontAwesomeIcon icon={['fas', 'filter']} size="xs" />
                                {t('filterSearch')}
                            </Button>
                            {props.isAddWorkOrderMode === false && (
                                <InventoryActionButtonContainer
                                    t={props.t}
                                    facility={props.facility}
                                    history={props.history}
                                    location={props.location}
                                    match={props.match}
                                    installBasesPopulated={tableData}
                                    colorButton={'blue'}
                                    resetSelection={resetSelection}
                                    onMenuToggle={onMenuToggle}
                                    hideVirtualDecommissioned={props.tableFilters.hideVirtualDecommissionedToggle || false}
                                    onHideVirtualChange={handleHideVirtualChange}
                                />
                            )}
                            {props.isAddWorkOrderMode === true && (
                                <Button
                                    onClick={props.toggleConfirmSelectJobModal}
                                    disabled={props.selection.length === 0}
                                    className="add-assets-btn-mobile"
                                    title={props.selection.length > 0 ? 'add' : 'must select at least one'}
                                >
                                    {props.t('addSelectedAssetToJob')}
                                </Button>
                            )}
                        </Col>
                    </div>
                )}
            </div>

            {props.loading ? (
                <div style={{ padding: '15px' }}>Loading...</div>
            ) : (
                <>
                    <div {...getTableProps()} className={`${tableClassName} flex-layout`}>
                        <div className="rt-thead -header sticky-header">
                            {headerGroups.map((headerGroup: any, index: number) => {
                                const { key: trKey, ...trProps } = headerGroup.getHeaderGroupProps();

                                return (
                                    <div key={trKey || index} {...trProps} className="rt-tr">
                                        {headerGroup.headers.map((column: any) => {
                                            const { key: thKey, ...thProps } = column.getHeaderProps(
                                                column.getSortByToggleProps()
                                            );

                                            return (
                                                <div key={thKey || column.id} {...thProps} className="rt-th">
                                                    <div>{column.render('Header')}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                            {productSyncChunksDone !== null && (
                                <div className="product-sync-banner">
                                    <FontAwesomeIcon icon={faSpinner} spin={true} size="sm" />
                                    <span>
                                        {t('productSyncBanner', {
                                            defaultValue:
                                                'Product names are still downloading (part {{part}} of 4). This can take several minutes on a slow connection.',
                                            part: Math.min(productSyncChunksDone + 1, 4)
                                        })}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div {...getTableBodyProps()} className="rt-tbody">
                            {tablePage.map((row: any, rowIndex: number) => {
                                prepareRow(row);
                                const { key: trKey, ...rowProps } = row.getRowProps();
                                const alreadyAdded = isAlreadyOnJob(row.original, isAddWorkOrderMode);

                                return (
                                    <div
                                        key={trKey || row.id}
                                        {...rowProps}
                                        className={`rt-tr ${rowIndex % 2 === 0 ? '-odd' : '-even'}${
                                            alreadyAdded ? ' already-added' : ''
                                        }`}
                                    >
                                        {row.cells.map((cell: any, cellIndex: number) => {
                                            const { key, ...rest } = cell.getCellProps();
                                            const tdKey = key || cell.column.id;
                                            const isCheckboxColumn = cell.column.id === 'selection';

                                            return (
                                                <div
                                                    key={tdKey}
                                                    {...rest}
                                                    className="rt-td"
                                                    onClick={
                                                        isCheckboxColumn || alreadyAdded
                                                            ? undefined
                                                            : e => {
                                                                  // Prevent if clicking on any input elements
                                                                  if ((e.target as HTMLElement).tagName === 'INPUT') {
                                                                      return;
                                                                  }

                                                                  handleRowClick(row);
                                                                  if (isRepairTypeJob) {
                                                                      toggleRowSelected(row.id);
                                                                  }
                                                              }
                                                    }
                                                >
                                                    {cell.render('Cell')}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="table-pagination">
                        <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn">
                            Previous
                        </button>

                        <div className="controls">
                            <label htmlFor="page-input">Page </label>
                            <span>
                                <input
                                    id="page-input"
                                    type="number"
                                    min={1}
                                    max={pageCount}
                                    className="page-input"
                                    defaultValue={pageIndex + 1}
                                    key={`page-input-${pageIndex}`}
                                    onChange={e => {
                                        const gotoPageNum = e.target.value ? Number(e.target.value) - 1 : 0;
                                        if (gotoPageNum >= 0 && gotoPageNum < pageCount) {
                                            gotoPage(gotoPageNum);
                                        }
                                    }}
                                    onWheel={e => e.currentTarget.blur()}
                                />
                            </span>
                            <span>of </span>
                            <span>{pageCount}</span>

                            <select
                                value={pageSize}
                                className="table-page-size-select"
                                onChange={e => {
                                    setPageSize(Number(e.target.value));
                                }}
                            >
                                {constants.tablePageSizeOptions.map(size => (
                                    <option key={size} value={size}>
                                        {size} {t('common:rows')}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <button onClick={() => nextPage()} disabled={!canNextPage} className="btn">
                            Next
                        </button>
                    </div>
                </>
            )}

            <EditProductModal colorButton={colorButton} selectedItem={props.selectedProduct} />
            <EditInstallModal
                selectedItem={state.selectedInstall}
                colorButton={colorButton}
                history={history}
                location={location}
                match={props.match}
            />
            {finalJobCheckModal && <JobFinalCheckModal t={props.t} />}
            <SignatureModal colorButton={colorButton} installBasesPopulated={tableData} />
            <CommissioningDataSignatureModal
                colorButton={constants.colors[`${currentTile.color}Button` as keyof typeof constants.colors]}
                selectedJob={selectedJob}
                installBasesPopulated={tableData}
            />
            <NoteModal colorButton="primary" filteredInstallBases={tableData} />
            <SearchNewProductsModal colorButton={colorButton} selectedItem={props.selectedProduct} />
            <WorkOrderCloseModal colorButton={colorButton} installBasesPopulated={tableData} />
            <EditJobModal colorButton={colorButton} selectedFacilityID={props.facility.id} dispatch={dispatch} />
            <AddHoursModalContainer colorButton={colorButton} wideModal={true} />
            <EditJobDefaultsModal colorButton={colorButton} selectedJobID={selectedJob.id} />
            <CommissioningDataModal colorButton={colorButton} selectedJobID={selectedJob.id} />
            <ConfirmSelectJobModal
                facilityID={selectedJob.facilityID}
                history={history}
                location={location}
                match={props.match}
                selectedInstallID={state.selectedInstall.id}
                forSAP={false}
            />
            <AddFSEModal selectedJob={selectedJob as IjobPopulated} t={props.t} />
            <JobCommentsModal />
            <EditFacilityContactsModal />
            <VirtualSapWOPartsModal />
            {mobileFilterConfig && searchFieldConfig !== undefined && (
                <FilterAssetTableModal
                    show={state.showFilterSearch}
                    closeFilterAssetModal={() => {
                        setState(currSt => ({ ...currSt, showFilterSearch: false }));
                    }}
                    bgColor="#3BB9EA"
                    brColor="#007BC3"
                    primaryColor="#007AC3"
                    setTableFilter={props.setTableFilter}
                    tableFilters={props.tableFilters}
                    clearTableFilter={clearTableFilter}
                    buildings={props.facility.buildings}
                    selectedJob={selectedJob}
                    productInfo={props.productInfo}
                    isWorkOrderTypeJob={isWorkOrderTypeJob}
                    isJobDownloaded={isJobDownloaded}
                    isAddWorkOrderMode={props.isAddWorkOrderMode}
                ></FilterAssetTableModal>
            )}
        </div>
    );
};

/*
 * AddCustomerModal will connect to redux, impliment CommonModal, as well as AddCustomerForm
 */

const makeMapStateToProps = () => {
    const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
        const selectedJob = state.manageJob.jobsByID[state.manageJob.selectedJob.id] || initialJob;
        const {
            facilities,
            manageInventory,
            syncStatus: { lastSync }
        } = state;
        const { openedInspectionJobIDs } = state.manageJob;
        const selectedFacility = facilities.facilitiesByID[selectedJob.facilityID] || initialFacility;
        const isJobDownloaded = selectOfflineStatusForJob(state, {
            job: selectedJob
        });

        const isWorkOrderTypeJob = getIsWorkOrderTypeJob(state);
        const isCommissioningTypeJob = getIsCommissioningTypeJob(state);
        const isMaintenanceTypeJob = getIsMaintenanceTypeJob(state);
        const isAddWorkOrderMode = getIsAddWorkOrderMode(state);
        // TODO Refactor into selector

        const noDataText = selectInventoryNoDataText(state);
        const isRepairTypeJob = selectedJob.jobTypeID === jobTypesIdEnum.repair;

        return {
            user: state.user,
            loading: selectIsLoading(state),
            lastSync,
            openedInspectionJobIDs,
            // workOrderUpdatedSuccess: getWorkOrderUpdatedSuccess(state),
            showNotePadModal: manageInventory.showNoteModal,
            showEditProductModal: manageInventory.showEditProductModal,
            showEditInstallModal: manageInventory.showEditInstallModal,
            showSignatureModal: manageInventory.showSignatureModal,
            showJobDefaultsModal: manageInventory.showEditJobDefaultsModal,
            showSearchNewProductsModal: manageInventory.showSearchNewProductsModal,
            facilityOptions: FormUtil.convertToOptions(state.user.facilities),
            productInfo: state.productInfo,
            tableFilters: manageInventory.tableFilters,
            selectedProduct: manageInventory.selectedProduct,
            selectedJob: state.manageJob.selectedJob,
            facility: selectedFacility,
            selection: manageInventory.selection,
            enableBulkInstallBaseMode: manageInventory.enableBulkInstallBaseMode,
            showAdditionalFilters: manageInventory.tableFilters.showAdditionalFilters,
            isWorkOrderTypeJob,
            isMaintenanceTypeJob,
            isAddWorkOrderMode,
            noDataText,
            isRepairTypeJob,
            isCommissioningTypeJob,
            isJobDownloaded
        };
    };

    return mapStateToProps;
};

export default withTranslation('manageInventory')(
    connect(makeMapStateToProps, {
        toggleCommissioningDataFormModal,
        toggleEditInstallModal,
        toggleAddRepairWorkOrderModal,
        toggleConfirmSelectJobModal,
        toggleModalSignaturePad,
        toggleModalNotePad,
        toggleEditJobDefaultsModal,
        setTableFilter: setTableFilterAction,
        setSelectedProduct,
        addWorkOrdersToJob,
        updateJob,
        updateInstallBaseSelection,
        setSelectedWorkOrderID,
        bulkCannotCompleteSelected,
        getCommissioningInstallBases,
        getMeasurementPointListResultsForJobs,
        getContactsByFacility,
        clearTableFilter
    })(ManageInventory)
);
